(() => {
  function init(root = document) {
    root.querySelectorAll('[data-product-section]').forEach(section => {
      const select = section.querySelector('[data-variant-select]');
      if (!select || select.dataset.ready) return;
      select.dataset.ready = 'true';
      select.addEventListener('change', () => {
        const option = select.selectedOptions[0];
        const price = section.querySelector('[data-product-price]');
        price.textContent = option.dataset.price + ' ';
        if (option.dataset.compare) { const s = document.createElement('s'); s.textContent = option.dataset.compare; price.append(s); }
        const button = section.querySelector('[data-add-button]');
        button.disabled = option.dataset.available !== 'true';
        button.textContent = button.disabled ? 'Sold out' : 'Add to bag ↗';
        if (option.dataset.media) { const media = section.querySelector('#Media-' + option.dataset.media); if (media) media.scrollIntoView({behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block:'nearest'}); }
        const url = new URL(location.href); url.searchParams.set('variant', option.value); history.replaceState({}, '', url);
      });
    });
    root.querySelectorAll('[data-countdown]').forEach(el => {
      if (el.dataset.ready) return;
      el.dataset.ready = 'true';
      const end = Date.parse(el.dataset.countdown);
      if (!Number.isFinite(end)) { el.hidden = true; return; }
      const output = el.querySelector('[data-countdown-output]');
      const tick = () => {
        if (!el.isConnected) return false;
        const seconds = Math.max(0, Math.floor((end - Date.now()) / 1000));
        if (!seconds) { output.textContent = el.dataset.liveText; return false; }
        output.textContent = `${Math.floor(seconds / 86400)}d : ${String(Math.floor(seconds / 3600) % 24).padStart(2,'0')}h : ${String(Math.floor(seconds / 60) % 60).padStart(2,'0')}m : ${String(seconds % 60).padStart(2,'0')}s`;
        return true;
      };
      if (tick()) { const timer = setInterval(() => { if (!tick()) clearInterval(timer); }, 1000); }
    });
  }
  init(); document.addEventListener('shopify:section:load', event => init(event.target));
})();
